import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { CustomerDetailInfoViewModel } from "src/app/frontoffice/parties/model/customer.model";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { BaseFormComponent } from "../../../../../../../projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";

@Component({
  selector: "ngx-address-phone-form",
  templateUrl: "./address-phone-form.component.html",
  styleUrls: ["./address-phone-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddressPhoneFormComponent extends BaseFormComponent<CustomerDetailInfoViewModel> {
  AddressId: number;
  PhoneId: number;
  erroremessage: string;
  CallerIdNumber: string;
  public columns2: form_control[] = [];
  constructor(public selectorService: SelectorService, public cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.label = this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.address-phone-form.ChoosingCustomerAddressAndTelephoneNumber");
    this.setdefault();
    this.setColumns();
  }
  setdefault() {
    this.AddressId = this.model.Addresses.length === 1 ? this.model.Addresses[0].Id : null;
    this.PhoneId = this.model.Numbers.find((f) => f.IsDefault).Id;
    if (this.CallerIdNumber && this.CallerIdNumber !== "") {
      this.PhoneId = this.model.Numbers.find((x) => x.Number === this.CallerIdNumber)?.Id;
    }
    this.model.Addresses.forEach((x) => (x.Address = (x?.Zone?.Title || "") + " - " + x.Address));
    this.addControl();
  }
  async setColumns() {
    this.columns = [];
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.address-phone-form.AddressId"),
      controlType: FormControlTypes.radioList,
      modelName: "AddressId",
      name: "AddressId",
      order: 1,
      textType: "number",
      formVisible: true,
      listVisible: true,
      required: true,
    });
    this.columns.push(<form_control>{
      label: this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.address-phone-form.radioboxPhoneId"),
      name: "PhoneId",
      order: 2,
      listVisible: true,
      formVisible: true,
      required: true,
      textType: "number",
      modelName: "PhoneId",
      controlType: FormControlTypes.radioList,
    });
    this.orignalColumns = this.columns;
    this.setFormGroup(this.model);
  }
  addControl() {
    this.setValue("AddressId", this.AddressId, true);
    this.setValue("PhoneId", this.PhoneId, true);
    this.cd.markForCheck();
  }
  isValid() {
    this.erroremessage = undefined;
    if (!this.formGroup.controls["AddressId"].value) {
      this.erroremessage = this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.address-phone-form.SelectingAddressRequired");
      return false;
    }
    if (!this.formGroup.controls["PhoneId"].value) {
      this.erroremessage = this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.address-phone-form.PhoneSelectionIsRequired");
      return false;
    }
    return true;
  }
  async save() {
    if (this.formGroup?.valid && this.isValid()) {
      this.result = { AddressId: this.formGroup.controls["AddressId"].value, PhoneId: this.formGroup.controls["PhoneId"].value };
      this.closeModal();
    } else this.selectorService.submitted$.next(this.submitted);
  }
}
